import { Button } from "antd";
import { useData } from "components/provider/data";
import { PieChart } from '@mui/x-charts/PieChart';

const chartSetting = {
    xAxis: [
        {
            label: 'USD',
        },
    ],
    height: 400,
    margin: { left: 0 },
};
const ProfitChartByUser = () => {
    const { tradeAccounts } = useData();

    // function groupByUser() {
    //     let groupedData: { user_id: string, login_id: string[], totalPnl: number, totalBalance: number }[] = [];
    //     for (const user of assignedAccountUser || []) {
    //         const userTrades = tradeHistoryChartData.filter(trade => {
    //             return Number(trade.label) == Number(user.account.login_id)
    //         });
    //         console.log('User Trades:', userTrades, 'for user:', user.account.login_id);
    //         if (userTrades.length > 0) {
    //             groupedData.push({
    //                 user_id: user.user.id,
    //                 login_id: userTrades.map(trade => trade.label),
    //                 totalPnl: userTrades.reduce((acc, trade) => acc + trade.data.reduce((sum, point) => sum + point.y, 0), 0),
    //                 totalBalance: user.account.balance

    //             });
    //         }
    //     }
    //     groupedData = groupedData.reduce((acc: { user_id: string, login_id: string[], totalPnl: number, totalBalance: number }[], curr) => {
    //         const existing = acc.find(item => item.user_id === curr.user_id);
    //         if (existing) {
    //             existing.login_id.push(...curr.login_id);
    //             existing.totalPnl += curr.totalPnl;
    //             existing.totalBalance += curr.totalBalance;
    //         } else {
    //             acc.push({ ...curr });
    //         }
    //         return acc;
    //     }, [] as { user_id: string, login_id: string[], totalPnl: number, totalBalance: number }[]);
    //     console.log('Grouped Data:', groupedData);

    //     return groupedData;
    // }

    function groupByUser() {
        let groupedData: {
            user: { id: string, name: string, email: string },
            account: {
                id: string,
                login_id: string,
                nickname: string,
                platform: string,
            },
            totalBalance: number,
            totalPnl: number,
            totalEquity: number,
        }[] = [];
        groupedData = tradeAccounts.map(account => {
            return {
                user: {
                    id: account.linked_user?.id ?? "0",
                    name: account.linked_user?.name ?? "N/A",
                    email: account.linked_user?.email ?? "N/A",
                },
                account: {
                    id: account.id,
                    login_id: account.login_id,
                    nickname: account.nickname,
                    platform: account.platform,
                },
                totalBalance: account.balance || 0,
                totalPnl: account.pl || 0,
                totalEquity: account.equity || 0,
            };
        });
        groupedData = groupedData.reduce((acc, curr) => {
            const existing = acc.find(item => item.user.id === curr.user.id);
            if (existing) {
                existing.account.login_id += `, ${curr.account.login_id}`;
                existing.totalBalance += curr.totalBalance;
                existing.totalPnl += curr.totalPnl;
                existing.totalEquity += curr.totalEquity;
            } else {
                acc.push({ ...curr });
            }
            return acc;
        }, [] as typeof groupedData);
        console.log('Grouped Data:', groupedData);


        return groupedData;
    }

    function getPieChartData() {
        const groupedData = groupByUser();
        // PieChart expects an array of objects with 'id', 'value', and 'label'
        const pieData = groupedData.map(user => ({
            id: user.account.login_id,
            value: user.totalBalance, // or use totalPnl or totalEquity as needed
            label: user.user.name,

        }));

        return pieData;
    }

    const pieChartData = getPieChartData();

    return (
        <>
            <div className="col-span-3" style={{ marginBottom: '16px', height: '300px' }}>
                <PieChart
                    series={[
                        {
                            data: pieChartData,
                            highlightScope: { fade: 'global', highlight: 'item' },
                            faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                            valueFormatter: (value, context) => {
                                const total = pieChartData.reduce((sum, item) => sum + item.value, 0);
                                const percent = total ? ((value.value / total) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00";
                                return `$${Number(value.value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} - ${percent}%`;
                            },
                            innerRadius: 30,
                            outerRadius: 100,
                            paddingAngle: 5,
                            cornerRadius: 5,
                            startAngle: -45,
                        }
                    ]}
                />
            </div>
        </>
    )
}

export default ProfitChartByUser;